import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import oeqActions from 'redux/actions/oeqActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import pickerSelector from 'redux/selectors/picker/picker_selector'

import Picker from 'views/picker/main_picker/picker'

class OEQReferenceMediaPicker extends PureComponent {

	constructor(props) {
		super(props)
		this.onFilePicked = this.onFilePicked.bind(this)
		this.onFileError = this.onFileError.bind(this)
	}

	onFilePicked(file, acceptedFiles) {
		this.props.actions.filePicked(acceptedFiles, file, false)
	}

	onFileError(message) {
		this.props.actions.fileError(message, this.props.questionId)
	}

	render() {
		return (
			<Picker
				onFilesPicked={this.onFilePicked}
				onFileError={this.onFileError}
				closeHandler={this.props.actions.closeModal}
				pickerType={this.props.pickerType}
				googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
			/>
		)
	}
}

OEQReferenceMediaPicker.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return pickerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: oeqActions.nearpodPickerCancel,
		filePicked: oeqActions.uploadReferenceMedia,
		fileError: oeqActions.uploadReferenceMediaError,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(OEQReferenceMediaPicker)
